import React, {Component} from 'react';
import classNames from 'classnames';

import styles from './MainHeader.less';

export default class Header extends Component {
	render() {
		const {
			className,
			children,
			...props
		} = this.props;

		return (
			<div className={classNames(styles['page-header'], className)} {...props}>
				{children}
			</div>
		);
	}
}